import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { LanguageSwitcherComponent } from '@app/shared/components/language-switcher/language-switcher.component';
import { DeviceInfoService } from '@core/services/device-info.service';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LanguageSwitcherComponent],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly deviceInfo = inject(DeviceInfoService);
  private readonly destroy$ = new Subject<void>();

  hideContainer = false;
  wideContainer = false;

  ngOnInit(): void {
    // Make sure every visit to /auth/* has a persisted device id ready
    // before the user fires `checkUsername` or `login` — those calls
    // pull the id from DeviceInfoService at request time.
    this.deviceInfo.ensureDeviceId();
    this.hideContainer = this.shouldHideContainer(this.router.url);
    this.wideContainer = this.shouldUseWideContainer(this.router.url);
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        this.hideContainer = this.shouldHideContainer(event.urlAfterRedirects);
        this.wideContainer = this.shouldUseWideContainer(
          event.urlAfterRedirects
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private shouldHideContainer(url: string | null | undefined): boolean {
    if (!url) {
      return false;
    }
    return url.includes('/auth/password-recovery/restriction-info');
  }

  private shouldUseWideContainer(url: string | null | undefined): boolean {
    if (!url) {
      return false;
    }
    return url.includes('/auth/initial-setup');
  }
}
